import config from "../config";
import { authHeader } from "../helpers";

const getNotification = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/notification`, requestOptions).then(
    handleResponse
  );
};

const getUnreadNotification = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/notification/count`, requestOptions).then(
    handleResponse
  );
}

const readNotification = () => {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/notification/read`, requestOptions).then(
    handleResponse
  );
}

const getNotificationStatus = (id) => {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };
  return fetch(
    `${config.atsApiUrl}/notification/seen/${id}`,
    requestOptions
  ).then(handleResponse);
};

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      if(response.status == 401){
        localStorage.clear()
        window.location.pathname = '/'
      }
      return Promise.reject(error);
    }
    return data;
  });
};

export const NotificationService = {
  getNotification,
  getUnreadNotification,
  readNotification,
  getNotificationStatus,
};
